<app-capital-container size="M" class="text-center">
    <app-capital-back></app-capital-back>
    <h1 class="home-title">¡Hola! Te damos la bienvenida</h1>
    <h2 class="home-subtitle">¿Cómo puedo ayudarte?</h2>
    <div class="row g-3 text-start">
        <div class="col-12 col-lg-6">
            <app-home-options-element title="Modificar mis datos"
                caption="Actualiza tus datos de una forma fácil y rápida." action="Actualizar datos"
                icon="/img/contract-edit.svg" route="/update-personal-data"></app-home-options-element>
        </div>
        <div class="col-12 col-lg-6">
            <app-home-options-element title="Necesito un certificado"
                caption="En pocos pasos imprime o envía los certificados a tu correo registrado."
                action="Obtener certificado" icon="/img/article.svg" route="/certificates"
                [isLoading]="certificadosService.isLoadingSignal()"></app-home-options-element>
        </div>
    </div>

    <div class="close-session">
        <p class="m-0" role="button" (click)="onLogout()" [class.disabled]="isLoggingOut()">
            {{ isLoggingOut() ? 'Cerrando sesión...' : 'Cerrar sesión' }}
        </p>
    </div>
</app-capital-container>